import { KnownPermission } from "../model";
import { useEffect, useState } from "react";
import { loadUser, User } from "@genai/user";
import { useQuery } from "@tanstack/react-query";

export async function hasPermissions(
  permissions: KnownPermission[],
  user?: User,
): Promise<boolean> {
  if (!user) return false;

  return permissions.includes(user.role as KnownPermission) ;
}

export function usePermissions(permissions: KnownPermission[]): {
  allowed: boolean;
  loading: boolean;
} {
  const [allowed, setAllowed] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const { data: currentUser } = useQuery({
    queryKey: ["currentUser"],
    queryFn: () => loadUser(),
  })

  useEffect(() => {
    hasPermissions(permissions, currentUser).then((result) => {
      setAllowed(result);
      setLoading(false);
    });
  }, [permissions, currentUser]);

  return { allowed, loading };
}
